import { useCallback } from "react";

import { useRetryRenewalSendOfferMutation } from "@covertree/agent-portal-graphql";
import { Toast } from "@covertree/utils";
import { getErrorMessageFromApolloError } from "@utils/getErrorMessageFromApolloError";
import { delayRefetchedQuery } from "@utils/delayRefetchedQuery";

export function useRetryRenewalSendOffer(shouldRefetchListAfterRetry = false) {
  const [retryRenewalSendOffer, { loading }] = useRetryRenewalSendOfferMutation(
    {
      refetchQueries: shouldRefetchListAfterRetry
        ? ["GetRenewalListItems"]
        : undefined,
      onQueryUpdated: shouldRefetchListAfterRetry
        ? delayRefetchedQuery
        : undefined,
    }
  );

  const retryRenewalSendOfferHandler = useCallback(
    async (renewalLocator: string) => {
      try {
        await retryRenewalSendOffer({
          variables: {
            renewalLocator,
          },
        });
        Toast.showSuccess("Sending renewal offer was retried successfully!");
      } catch (error) {
        Toast.showError(
          getErrorMessageFromApolloError(error) ||
            "Retry send offer failed. Please try again or contact tech team on fuji-san channel."
        );
      }
    },
    [retryRenewalSendOffer]
  );

  return {
    retryRenewalSendOffer: retryRenewalSendOfferHandler,
    loading,
  };
}
